module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Th.ad11c29.woff2";